import { render, staticRenderFns } from "./compare-dropdowns.vue?vue&type=template&id=3a05a8b0&scoped=true&"
import script from "./compare-dropdowns.vue?vue&type=script&lang=ts&"
export * from "./compare-dropdowns.vue?vue&type=script&lang=ts&"
import style0 from "./compare-dropdowns.vue?vue&type=style&index=0&id=3a05a8b0&lang=scss&scoped=true&"
import style1 from "./compare-dropdowns.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05a8b0",
  null
  
)

export default component.exports